import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import { Users, UserCheck, BookOpen, FlaskConical, GraduationCap } from 'lucide-react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const cardVariants = {
  hidden: { 
    opacity: 0, 
    y: 50, 
    scale: 0.95,
  },
  visible: { 
    opacity: 1, 
    y: 0, 
    scale: 1,
    transition: {
      duration: 0.6,
      ease: [0.23, 1, 0.32, 1],
    }
  }
};

const StatCard = ({ icon: Icon, end, label }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <motion.div
      ref={ref}
      variants={cardVariants}
      className="bg-white p-6 rounded-xl shadow-lg text-center flex flex-col items-center transition-all duration-300 hover:shadow-red-500/20 hover:shadow-xl hover:-translate-y-1"
    >
      <div className="bg-red-100 p-3 rounded-full mb-4">
        <Icon size={32} className="text-red-600" />
      </div>
      <div className="text-4xl font-extrabold text-gray-900">
        {inView ? <CountUp end={end} duration={3} separator="." /> : '0'}
      </div>
      <p className="text-gray-500 mt-2 text-md font-semibold">{label}</p>
    </motion.div>
  );
};

const StatsCounter = () => {
  const { t } = useTranslation();

  const stats = [
    { icon: Users, end: 2627, label: t('home.stats.undergraduateStudents') },
    { icon: UserCheck, end: 511, label: t('home.stats.graduateStudents') },
    { icon: BookOpen, end: 183, label: t('home.stats.facultyMembers') },
    { icon: FlaskConical, end: 103, label: t('home.stats.activeProjects') },
    { icon: GraduationCap, end: 15824, label: t('home.stats.totalAlumni') },
  ];

  return (
    <motion.div
      className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >
      {stats.map((stat, index) => (
        <StatCard key={index} {...stat} />
      ))}
    </motion.div>
  );
};

export default StatsCounter; 